<template>
  <div class="mapping-modal">
    <app-modal :withCancel="true" v-on:cancel="reset()" v-on:ok="submitData()">
      <h3 slot="header">Pilih Topik: <strong v-if="selectedCard !== null">{{selectedCard.name}}</strong></h3>
      <div slot="body" class="row">
        <div class="input-group m-b-10">
          <input type="text" class="form-control" placeholder="Masukan kata kunci pencarian ..." v-model="query">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
        </div>
        <p v-if="filteredCards.length === 0 && selectedCard !== null">Tidak ada data lagi di bawah topik ini</p>
        <button v-on:click="onCardSelected(card)" v-for="(card, index) in filteredCards" v-bind:key="index" class="btn btn-lg btn-inverse btn-block col-md-12 p-10">
          <img :src="card.picture" style="max-width: 50px; align: left">
          <span>{{card.name}}</span>
        </button>
      </div>
    </app-modal>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import Modal from '@/components/plugins/Modal'
import Spinner from '@/components/plugins/Spinner'
import ItembankService from '@/services/itembank.js'

export default {
  name: 'mapping-modal',
  components: {
    'app-modal': Modal,
    'app-spinner': Spinner
  },
  data: function () {
    return {
      mapels: [],
      cards: [],
      filteredCards: [],
      topics: null,
      isLoading: false,
      mapelId: null,
      babId: null,
      subBabId: null,
      selectedCard: null,
      query: ''
    }
  },
  mounted: function () {
    var mapels = JSON.parse(localStorage.mapels)
    this.mapels = mapels

    var context = this
    this.mapels.forEach(function (mapel) {
      var card = {
        id: mapel.id,
        type: 'mapel',
        picture: mapel.picture != null ? mapel.picture : 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
        code: mapel.code,
        name: mapel.nama
      }

      context.cards.push(card)
    })

    this.filteredCards = this.cards
  },
  watch: {
    query: function (val) {
      var filtered = this.cards.filter(function (card) {
        return card.name.toLowerCase().includes(val.toLowerCase())
      })

      this.filteredCards = filtered
    },
    cards: function (val) {
      this.filteredCards = val
      this.query = ''
    }
  },
  methods: {
    onCardSelected: function(card) {
      var context = this
      this.selectedCard = card

      if (!this.topics) {
        this.cards = []
        this.mapelId = card.id
        this.isLoading = true
        ItembankService.getListOfTopic(card.code, function (response) {
          if (response.success) {
            context.topics = response.data
            context.topics.forEach(function (topic) {
              var card = {
                id: topic.id,
                type: 'bab',
                picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
                code: topic.code,
                name: topic.nama
              }
              context.cards.push(card)
            })
          }
          context.isLoading = false
        })
      } else {
        this.isLoading = true
        if (card.type === 'bab') this.babId = card.id
        else if (card.type === 'sub_bab') this.subBabId = card.id
        else if (card.type === 'sub_sub_bab') this.subSubBabId = card.id

        var context = this
        var data = []

        if (this.babId) {
          data = this.topics.find(function (topic) {
            return topic.id === context.babId
          })
        }

        if (this.subBabId) {
          var tmp = data.subs.find(function (d) {
            return d.id === context.subBabId
          })

          data = tmp
        }

        if (this.subSubBabId) {
          this.cards = []
          this.isLoading = false
          return
        }

        this.cards = []
        var cardType = 'bab'
        if (this.babId) cardType = 'sub_bab'
        if (this.subBabId) cardType = 'sub_sub_bab'

        data.subs.forEach(function (d) {
          var card = {
            id: d.id,
            type: cardType,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            code: d.code,
            name: d.nama
          }
          context.cards.push(card)
        })

        this.isLoading = false
      }
    },
    submitData: function () {
      this.isLoading = true
      var gradeId = this.$route.query.grade_id
      var interest = this.$route.query.interest

      var context = this
      ItembankService.createTopicMapping(
        this.mapelId,
        this.babId,
        this.subBabId,
        this.subSubBabId,
        gradeId,
        interest,
        function (response) {
          context.isLoading = false
          if (response.success) {
            context.$emit('finish')
          }
        }
      )
    },
    reset: function () {
      this.topics = null
      this.mapelId = null
      this.babId = null
      this.subBabId = null
      this.$emit('cancel')
    }
  }
}
</script>




// WEBPACK FOOTER //
// MappingModal.vue?24af0629